import styles from "./Info.module.css";

const Info = ({ result }) => {
  return (
    <div className={styles.infoContainer}>
      <h5 style={{ color: "#ff8c5a", fontWeight: "bold" }}>{result}</h5>
      {result.toLowerCase().includes("golden") && (
        <p>
          โกลเดินรีทรีฟเวอร์ มีถิ่นกำเนิดในประเทศสกอตแลนด์ มีขนยาว
          มีสีขนเหลืองอ่อน เหลืองทอง และเหลืองเข้ม โดยทั่วไปแล้ว
          เพศผู้ควรมีความสูง ประมาณ 23- 24 นิ้ว และเพศเมียควรมีความสูงประมาณ
          21.5-22.5 นิ้ว
          แต่เดิมนั้นสายพันธุ์นี้ได้ปรับปรุงคุณลักษณะบางอย่างเพื่อในงานของนายพราน
          เช่น มีรูปร่างสมส่วน คล่องตัว
          เขียวและฟันงับชิ้นเหยื่อโดยให้ช้ำเพียงเล็กน้อย เป็นต้น
          ไม่มีปรากฏว่าสุนัขสายพันธุ์นี้มีความก้าวร้าวแต่อย่างใด
          โกลเดินรีทรีฟเวอร์
          เป็นสุนัขที่มีความเฉลียวฉลาดมากมากจนสามารถนำมาฝึกเป็นสุนัขตำรวจ
          เนื่องจากมีประสาทสัมผัสที่ดีทั้งในด้านของการฟังเสียง การดมกลิ่นสะกดรอย
          นอกจากนี้ยังมีสายตาอันเฉียบคมและแม่นยำ (ที่มา: Wikipedia)
        </p>
      )}
      {result.toLowerCase().includes("labrador") && (
        <p>
          แลบราดอร์ริทรีฟเวอร์ มีต้นตระกูลอยู่ที่รัฐนิวฟันด์แลนด์และแลบราดอร์
          ชายฝั่งทะเลของประเทศแคนาดา มีขนสั้น มีขนสีดำ, เหลือง หรือช็อกโกแลต
          ในช่วงต้นศตวรรษที่ 19
          ได้มีการนำสุนัขพันธุ์นี้ไปยังสหราชอาณาจักรทางเรือประมง
          และต่อมาก็ได้มีการพัฒนาสายพันธุ์และเลี้ยงขึ้นมาในฐานะสุนัขล่าเหยื่อ
          และยังถูกใช้เป็นสุนัขกู้ภัย
          เพราะสามารถเคลื่อนที่ได้เร็วแม้ในภูมิประเทศที่ขรุขระหรือแม้กระทั่งพื้นที่ที่ปกคลุมด้วยน้ำแข็ง
          แลบราดอร์ริทรีฟเวอร์เป็นที่รู้จักกันดีในเรื่องความอดทน เข้มแข็ง
          มีความสามารถในการดมกลิ่นที่ดีเยี่ยม ชอบเอาใจผู้อื่น
          และชอบเล่นกับเจ้าของ (ที่มา: Wikipedia)
        </p>
      )}
      {result.toLowerCase().includes("kuvasz") && (
        <p>
          คูวาสซ์เป็นสุนัขขนาดใหญ่ เขามีความยาวมากกว่าความสูง
          ดังนั้นจึงมีร่างกายเป็นทรงสามเหลี่ยม เขาไม่ใช่สุนัขตัวหนา เทอะทะ
          แต่ในทางกลับกันเขามีรูปร่างกระฉับกระเฉงและแข็งแกร่ง
          หูพับมาด้านหน้าและไม่ตั้งชันขึ้น หางขดม้วนยกขึ้น เมื่อตื่นตัว ศรีษะยาว
          คูวาสซ์มีสีขาว ถึงแม้ว่าจะหลากหลายเฉดกันไป ขนสองชั้นยาวปานกลางและหนา
          มีทั้งแบบตรง เป็นลอนและหยิก คูวาสซ์เป็นสุนัขอารักขา
          ดังนั้นเขาอาจจะระแวงคนแปลกหน้าและปกป้องครอบครัวและบ้านของเขา
          มีอารมณ์ขันและมีความเป็นตัวของตัวเอง
          สุนัขพันธุ์นี้ฉลาดมากบวกกับความเป็นตัวของตัวเองตั้งแต่กำเนิด
          จึงควรได้รับการฝึกอย่างมั่นคงและเข้มข้นรวมถึงด้านการเข้าสังคมด้วย
          (ที่มา: Hills.co.th)
        </p>
      )}
    </div>
  );
};

export default Info;
